// @ts-strict-ignore
import { FloatRangeVO } from '@project/components/article/model/vo/property.vo';
import { NumberUtils } from '@shared/util/number-utils';

export class TextCheckSpacingData {
  public spacing: number;
  public spacingInRange: FloatRangeVO = null;

  public constructor(spacing: number, spacingInRange: FloatRangeVO = null) {
    this.spacing = spacing;
    this.spacingInRange = spacingInRange;
  }

  public getAverageSpacing(): number {
    let calculatedSpacing: number = NaN;
    if (NumberUtils.isNumber(this.spacing)) {
      calculatedSpacing = this.spacing;
    } else if (this.spacingInRange) {
      calculatedSpacing = (this.spacingInRange.left + this.spacingInRange.right) / 2;
    }
    return calculatedSpacing;
  }

  public equals(object: TextCheckSpacingData): boolean {
    const spacingData: TextCheckSpacingData = object;
    if (!spacingData) {
      return false;
    }
    return this.isSameSpacing(this.spacing, spacingData.spacing) &&
      this.isSameSpacingInRange(this.spacingInRange, spacingData.spacingInRange);
  }

  private isSameSpacing(firstSpacing: number, secondSpacing: number): boolean {
    return (NumberUtils.isNotNumber(firstSpacing) && NumberUtils.isNotNumber(secondSpacing)) || firstSpacing === secondSpacing;
  }

  private isSameSpacingInRange(firstSpacingInRange: FloatRangeVO, secondSpacingInRange: FloatRangeVO): boolean {
    return (!firstSpacingInRange && !secondSpacingInRange) || (firstSpacingInRange && firstSpacingInRange.equals(secondSpacingInRange));
  }
}
